export default __webpack_public_path__ + "static/media/globe_icon.c33f9c86.svg";